var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1280.000000pt",
    height: "2560.000000pt",
    viewBox: "0 0 1280.000000 2560.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,2560.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11065 23869 c-83 -8 -186 -45 -258 -93 -29 -20 -2403 -2387 -5348 -5333 -4973 -4976 -5298 -5302 -5327 -5363 -46 -96 -63 -172 -63 -280 0 -108 17 -184 63 -280 29 -61 353 -387 5347 -5381 4994 -4994 5320 -5318 5381 -5347 98 -47 172 -63 287 -63 117 0 217 28 313 86 37 23 242 222 616 597 507 510 563 569 592 628 46 96 63 172 63 280 0 109 -17 180 -63 277 -30 63 -93 129 -808 850 -426 429 -2475 2485 -4554 4567 l-3778 3786 3768 3776 c2073 2077 4122 4132 4554 4567 725 731 788 797 818 860 46 97 63 168 63 277 0 108 -17 184 -63 280 -29 59 -85 118 -592 628 -374 375 -579 574 -616 597 -114 70 -246 98 -395 84z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.bde5d96e6b4e31e4daf91784687c72c9.svg";
export { ForwardRef as ReactComponent };